
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray, singleton as singleton_1, toArray as toArray_1, map, isEmpty, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { toList, empty as empty_1, singleton, append, delay, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ConsumableState, ConsumableState__ToI18nString, Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { Table_customPropertyColumnDefinitions } from "../../Widgets/CustomProperties.js";
import Calendar_Add from "../../../public/assets/icons/Calendar_Add.svg";
import { TableControlElement$1, TableControl$1 } from "../../Widgets/Table/Table.js";
import Following from "../../../public/assets/icons/Following.svg";
import Followers from "../../../public/assets/icons/Followers.svg";
import { MultiAssignModalSheet } from "../../Widgets/Modals/MultiAssignModal.js";
import { Msg } from "./Types.js";
import { MultiUnassignModalSheet } from "../../Widgets/Modals/MultiUnassignModal.js";
import { MultiReservationModalSheet } from "../../Widgets/Modals/MultiReservationModal.js";
import { MultiReminderModalSheet } from "../../Widgets/Modals/MultiReminderModal.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import { RouterModule_nav, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrapConsumableId } from "../../Shared/Helper.js";
import { getQueryParams } from "../../Common.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import { Button } from "../../Components/Button.js";
import Shipment_Add from "../../../public/assets/icons/Shipment_Add.svg";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initOverview } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function ConsumablesTable(props) {
    let TableRows, Options;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState([false, [empty(), empty(), empty()]]);
    const setIsAssignModalSheetOpen = patternInput_1[1];
    const isAssignModalSheetOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState([false, [empty(), empty(), empty()]]);
    const setIsUnassignModalSheetOpen = patternInput_2[1];
    const isUnassignModalSheetOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState([false, empty()]);
    const setIsMultipleReservationToolModalSheetOpen = patternInput_3[1];
    const isMultipleReservationConsumableModalSheetOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState([false, empty()]);
    const setIsMultipleReminderConsumableModalSheetOpen = patternInput_4[1];
    const isMultipleReminderConsumableModalSheetOpen = patternInput_4[0];
    const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (dto) => (new CellContent(4, [dto.ImageUrl])), "none", "image")), delay(() => append(singleton(new ColumnDefinition$1("name", t("general.master_data"), t("general.name"), (consumable) => (new CellContent(0, [consumable.Name])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("additional_name", t("general.master_data"), t("consumable.additional_name"), (consumable_1) => (new CellContent(0, [consumable_1.AdditionalName])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventory_number", t("general.master_data"), t("consumable.inventory_number"), (consumable_2) => (new CellContent(0, [consumable_2.InventoryNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("description", t("general.master_data"), t("general.description"), (consumable_3) => (new CellContent(0, [consumable_3.Description])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("label", t("general.master_data"), t("tool.label"), (consumable_4) => (new CellContent(3, [consumable_4.Labels])), "categorySelect", "text")), delay(() => append(props.AccountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnit", t("general.master_data"), t("business_units.business_unit"), (consumable_5) => (new CellContent(0, [consumable_5.BusinessUnitName])), "select", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("location", t("general.master_data"), t("general.location"), (consumable_6) => (new CellContent(0, [consumable_6.Location])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("storage", t("general.master_data"), t("general.storage"), (consumable_7) => (new CellContent(0, [consumable_7.Storage])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("StorageSpace", t("general.master_data"), t("tool.storage_space"), (consumable_8) => (new CellContent(0, [consumable_8.StorageSpace])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("storageStock", t("general.master_data"), t("general.stock"), (consumable_9) => (new CellContent(0, [concat(consumable_9.StorageStock, " ", ...t(Helper_unitToTranslationKey(consumable_9.Unit)))])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("stockQuantity", t("general.master_data"), t("dashboard.minimum_stock"), (dto_1) => (new CellContent(0, [dto_1.MinimumStorageStock])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", t("general.master_data"), t("general.qr_code"), (consumable_10) => (new CellContent(0, [consumable_10.QRCodeIds])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("state", t("general.master_data"), t("general.state"), (consumable_11) => (new CellContent(0, [t(ConsumableState__ToI18nString(consumable_11.State))])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("purchase_price", t("tool.commercial_data"), t("general.purchase_price"), (consumable_12) => (new CellContent(0, [consumable_12.PurchasePrice])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("purchaseDate", t("tool.commercial_data"), t("general.purchase_date"), (consumable_13) => (new CellContent(6, [consumable_13.PurchaseDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("supplier", t("tool.commercial_data"), t("general.supplier"), (consumable_14) => (new CellContent(0, [consumable_14.Supplier])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("supplier_artice_number", t("tool.commercial_data"), t("general.supplier_article_number"), (consumable_15) => (new CellContent(0, [consumable_15.SupplierArticleNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("warranty_date", t("tool.commercial_data"), t("general.gurantee_date"), (consumable_16) => (new CellContent(6, [consumable_16.WarrantyDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("commercial_data_comment", t("tool.commercial_data"), t("general.comment"), (consumable_17) => (new CellContent(0, [consumable_17.CommercialDataComment])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("lastSeen", t("general.master_data"), t("general.last_seen"), (consumable_18) => (new CellContent(6, [consumable_18.LastSeen])), "dateRange", "date")), delay(() => Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (dto_2) => dto_2.CustomProperties, t, props.CustomerConfiguration.Currency)))))))))))))))))))))))))))))))))))))))))))));
    const reserveAction = new TableControlElement$1(0, [new TableControl$1(t("general.reserve"), Calendar_Add(), (selectedConsumables) => {
        if (isEmpty(selectedConsumables)) {
        }
        else {
            setIsMultipleReservationToolModalSheetOpen([true, map((selectedConsumable) => selectedConsumable.Id, selectedConsumables)]);
        }
    }, true, false, "")]);
    const reminderAction = new TableControlElement$1(0, [new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (selectedConsumables_1) => {
        if (isEmpty(selectedConsumables_1)) {
        }
        else {
            setIsMultipleReminderConsumableModalSheetOpen([true, map((selectedConsumable_1) => selectedConsumable_1.Id, selectedConsumables_1)]);
        }
    }, true, false, "")]);
    const assignAction = new TableControlElement$1(0, [new TableControl$1(t("general.assign"), Following(), (selectedConsumables_2) => {
        if (isEmpty(selectedConsumables_2)) {
        }
        else {
            setIsAssignModalSheetOpen([true, [empty(), empty(), map((consumable_19) => consumable_19.Id, selectedConsumables_2)]]);
        }
    }, true, false, "")]);
    const takeBackAction = new TableControlElement$1(0, [new TableControl$1(t("general.take_back"), Followers(), (consumables) => {
        if (isEmpty(consumables)) {
        }
        else {
            setIsUnassignModalSheetOpen([true, [empty(), empty(), map((consumable_20) => consumable_20.Id, consumables)]]);
        }
    }, true, false, "")]);
    const xs = [createElement(MultiAssignModalSheet, {
        AssignProps: {
            ConsumableIds: isAssignModalSheetOpen[1][2],
            SetIds: empty(),
            ToolIds: empty(),
        },
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isAssignModalSheetOpen[0],
        OnClose: () => {
            setIsAssignModalSheetOpen([false, [empty(), empty(), empty()]]);
        },
        PredefinedQuantities: empty(),
        SuccessCallback: () => {
            props.Dispatch(new Msg(0, []));
        },
        UserData: props.UserData,
    }), createElement(MultiUnassignModalSheet, {
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isUnassignModalSheetOpen[0],
        OnClose: () => {
            setIsUnassignModalSheetOpen([false, [empty(), empty(), empty()]]);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(0, []));
        },
        UnassignProps: {
            ConsumableIds: isUnassignModalSheetOpen[1][2],
            SetIds: empty(),
            ToolIds: empty(),
        },
        UserData: props.UserData,
    }), createElement(MultiReservationModalSheet, {
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isMultipleReservationConsumableModalSheetOpen[0],
        OnClose: () => {
            setIsMultipleReservationToolModalSheetOpen([false, empty()]);
        },
        ReservationProps: {
            ConsumableIds: isMultipleReservationConsumableModalSheetOpen[1],
            SetIds: empty(),
            ToolIds: empty(),
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(0, []));
        },
        UserData: props.UserData,
    }), createElement(MultiReminderModalSheet, {
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isMultipleReminderConsumableModalSheetOpen[0],
        OnClose: () => {
            setIsMultipleReminderConsumableModalSheetOpen([false, empty()]);
        },
        ReminderProps: {
            ConsumableIds: isMultipleReminderConsumableModalSheetOpen[1],
            SetIds: empty(),
            ToolIds: empty(),
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(0, []));
        },
        UserData: props.UserData,
    }), createElement(InfiniteTable, (TableRows = toArray_1(props.Consumables), (Options = {
        BorderStyle: "full",
        CSVDownload: true,
        ConfigurableColumns: true,
        CustomTableFilters: true,
        DefaultColumnFilter: singleton_1({
            id: "state",
            value: [t(ConsumableState__ToI18nString(new ConsumableState(0, [])))],
        }),
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: true,
        OnRowClick: new OnTableRowClick$1(1, [(consumable_21) => RouterModule_encodeParts(ofArray(["consumables", unwrapConsumableId(consumable_21.Id) + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1)]),
        RowSelection: "multiRow",
        SaveTableConfiguration: true,
        WithQueryParameters: true,
    }, {
        ColumnDefinitions: columnDefinitions,
        Controls: toList(delay(() => append(singleton(assignAction), delay(() => append(singleton(takeBackAction), delay(() => {
            let matchValue;
            return append((matchValue = props.UserData.Role, (matchValue === "toolManager") ? singleton(reserveAction) : ((matchValue === "system") ? singleton(reserveAction) : ((matchValue === "user") ? (props.CustomerConfiguration.IsSelfServiceReservationForUserActive ? singleton(reserveAction) : (empty_1())) : singleton(reserveAction)))), delay(() => {
                const matchValue_1 = props.UserData.Role;
                switch (matchValue_1) {
                    case "user": {
                        return empty_1();
                    }
                    default:
                        return singleton(reminderAction);
                }
            }));
        })))))),
        Options: Options,
        TableKey: "consumables-table",
        TableRows: TableRows,
    })))];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function ConsumablesOverview(props) {
    let elems_2, elems_1;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "pb-2"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-4"])], (elems = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: false,
                Label: t("general.tool"),
                OnClick: () => {
                    RouterModule_nav(ofArray(["tools"]), 1, 1);
                },
                TestId: "",
            }, {
                IsSelected: true,
                Label: t("general.consumable"),
                OnClick: () => {
                    RouterModule_nav(ofArray(["consumables"]), 1, 1);
                },
                TestId: "",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["grow"]),
        })), delay(() => {
            let Label_2;
            const matchValue = props.UserData.Role;
            switch (matchValue) {
                case "user": {
                    return empty_1();
                }
                default:
                    return singleton(createElement(Button, (Label_2 = t("consumable.create_new_consumable"), {
                        ComponentState: "enabled",
                        Icon: Shipment_Add(),
                        Label: Label_2,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["consumables", "new"]), 1, 1);
                        },
                        TestId: "add-new-consumables-button",
                        Variant: "primary",
                    })));
            }
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(ConsumablesTable, {
        AccountSettings: props.AccountSettings,
        Consumables: props.Consumables,
        Customer: props.Customer,
        CustomerConfiguration: props.CustomerConfiguration,
        Dispatch: props.Dispatch,
        PropertyConfigurations: props.PropertyConfigurations,
        UserData: props.UserData,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function ConsumablesOverviewView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initOverview, update_1, (_arg, _arg_1) => {
    }), props.UserData, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Consumables;
    const matchValue_1 = state_1.PropertyConfigurations;
    const matchValue_2 = state_1.CustomerConfiguration;
    let matchResult, consumables, customerConfiguration, propertyConfigurations;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        consumables = matchValue.fields[0];
        customerConfiguration = matchValue_2.fields[0];
        propertyConfigurations = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ConsumablesOverview, {
                AccountSettings: props.AccountSettings,
                Consumables: consumables,
                Customer: state_1.Customer,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                PropertyConfigurations: propertyConfigurations,
                UserData: state_1.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

